import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { Action } from 'redux';
import { County } from 'src/app/angular-elements/shared/interfaces/zip-county-response.interface';
import { environment } from '../../../../../environments/environment';

export const ZIP_COUNTY_STATE_NAME = 'ZipCounty';
const INITIAL_STATE: ZipCountyStateStructure = {
  zipCode: environment.initData.brand.defaultZip || '',
  county: environment.initData.brand.zipCountyMock || null
};

const SAVE_ZIP_COUNTY = 'SAVE_ZIP_COUNTY';
const RESET_ZIP_COUNTY = 'RESET_ZIP_COUNTY';
const INIT_ZIP_COUNTY = 'INIT_ZIP_COUNTY';

export class ZipCountyAction implements Action {
  type: string;
  zipCode?: string;
  county?: County;
}

export function saveZipCounty(zipCode: string, county: County) {
  return {
    type: SAVE_ZIP_COUNTY,
    zipCode,
    county
  };
}

export function ZipCounty(state: ZipCountyStateStructure = INITIAL_STATE, action: ZipCountyAction) {

  const copiedState: ZipCountyStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    case SAVE_ZIP_COUNTY:
      copiedState.zipCode = action.zipCode;
      copiedState.county = action.county;
      return Object.assign({}, state, copiedState);
    case RESET_ZIP_COUNTY:
      return INITIAL_STATE;
    case INIT_ZIP_COUNTY:
    default:
      return state;
  }
}
